import React from "react";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* ========== 100VH BANNER SECTION WITH PATTERNS ========== */}
      <section
        className="relative min-h-[100svh] flex items-center overflow-hidden bg-gradient-to-b from-white via-blue-50/30 to-white py-20 lg:py-0"
        aria-labelledby="hero-heading"
      >
        {/* Decorative Background Elements using Brand Blue */}
        <div className="absolute top-0 right-0 -translate-y-12 translate-x-12 blur-3xl opacity-10 pointer-events-none">
          <div className="aspect-square w-[500px] rounded-full bg-[#2467B1]" />
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">

            {/* Left Column: Content */}
            <div className="max-w-3xl order-2 lg:order-1">
              {/* Badge using Brand Red/Blue accents */}
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-50 border border-[#2467B1]/20 mb-6">
                <span className="h-2 w-2 rounded-full bg-[#CE3231] animate-pulse" />
                <span className="text-xs font-bold text-[#2467B1] tracking-widest uppercase">
                  Live Online English Coaching
                </span>
              </div>

              {/* Heading */}
              <h1
                id="hero-heading"
                className="text-[2.3rem] sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#2467B1] leading-[1.1] tracking-tight mb-6"
              >
                Speak English with clarity and confidence{" "}
                <span className="block text-[#2D2D2D] "> 
                  — for work and life.
                </span>
              </h1>

              {/* Subheading with Brand Blue border */}
              <div className="border-l-4 border-[#2467B1] pl-5 mb-10">
                <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-xl">
                  Practical lessons, live practice, and real feedback for grown-ups.
                  <br className="hidden sm:block" />
                  <span className="text-gray-600 font-bold">
                    No needless grammar drills
                  </span>{" "}
                  — just the language you need to get things done.
                </p>
              </div>

              {/* CTA Buttons - Matching Logo Blue */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => navigate("/contact")}
                  className="px-8 py-4 bg-[#2467B1] hover:bg-[#1a4d85] text-white font-bold rounded-full shadow-lg shadow-blue-900/20 transition-all active:scale-95"
                >
                  Start Trial
                </button>

                <button
                  onClick={() => navigate("/courses")}
                  className="px-8 py-4 bg-white hover:bg-gray-50 text-[#2D2D2D] font-bold rounded-full border-2 border-[#2467B1] transition-all active:scale-95"
                >
                  View Courses
                </button>
              </div>
            </div>

            {/* Right Column: Visual Image */}
            <div className="relative order-1 lg:order-2 flex justify-center">
              <div className="relative w-full max-w-[600px]">
                {/* Soft decorative glow using logo colors */}
                {/* <div className="absolute inset-0 bg-[#2467B1] rounded-3xl rotate-3 scale-105 opacity-10" /> */}

                <div className="relative overflow-hidden rounded-3xl shadow-2xl border-4 border-white">
                  <img
                    src="/herobanner.png"
                    alt="Well Spoken coaching session"
                    className="w-full h-full object-cover transform hover:scale-105 transition-all duration-700"
                    loading="eager"
                  />
                </div>

                {/* Floating Social Proof Card */}
                {/* <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl hidden md:flex items-center gap-4 border border-gray-100">
                  <div className="flex -space-x-3">
                    {[1, 2, 3].map(i => (
                      <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-blue-100 flex items-center justify-center text-[10px] font-bold text-[#2467B1]">
                        WS
                      </div>
                    ))}
                  </div>
                  <div className="text-sm">
                    <p className="font-bold text-[#2D2D2D]">Join 1,200+ Learners</p>
                    <p className="text-[#CE3231] text-xs font-medium">Expert feedback provided</p>
                  </div>
                </div> */}
              </div>
            </div>

          </div>
        </div>

        {/* Trust Indicator */}
        {/* <div className="absolute bottom-10 right-10 hidden xl:block">
          <div className="bg-white/5 backdrop-blur-xl p-4 rounded-2xl border border-white/10 flex items-center gap-4"> */}
        {/* Avatars */}
        {/* <div className="flex -space-x-2">
              {["/logo192.png", "/logo512.png", "/logo192.png"].map(
                (src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt="Learner"
                    className="w-10 h-10 rounded-full object-cover border-2 border-slate-900 bg-slate-700"
                  />
                ),
              )}
            </div> */}

        {/* Text */}
        {/* <div className="text-sm">
              <p className="text-white font-semibold">500+ Learners</p>
              <p className="text-slate-400">Improved confidence this year</p>
            </div> */}
        {/* </div>
        </div> */}
      </section>

      {/* ========== REFINED FEATURES & LESSON SECTION ========== */}
      <section className="relative bg-gradient-to-b from-white via-blue-50 to-indigo-50 py-10 lg:py-20 overflow-hidden">
        {/* Enhanced Floating Shapes */}
        <div
          className="absolute inset-0 overflow-hidden pointer-events-none"
          aria-hidden="true"
        >
          <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-gradient-to-br from-blue-200/70 to-purple-200/70 rounded-full blur-3xl opacity-40 animate-float-slow" />
          <div className="absolute bottom-0 left-0 w-[450px] h-[450px] bg-gradient-to-tr from-indigo-200/70 to-pink-200/70 rounded-full blur-3xl opacity-40 animate-float-slow delay-1000" />
          <div className="absolute top-1/3 left-1/4 w-72 h-72 bg-gradient-to-r from-blue-100/50 to-indigo-100/50 rounded-2xl blur-xl opacity-30 animate-pulse-slow" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Features Grid - Now 3 Cards for Balance */}
          <div className="max-w-6xl mx-auto mb-24">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-2xl shadow-xl border border-blue-200 mb-8 backdrop-blur-sm">
                <span className="text-2xl" role="img" aria-label="Rocket">
                  🚀
                </span>
                <span className="text-base font-bold text-blue-700 uppercase tracking-widest">
                  Why Choose Us
                </span>
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-6 leading-tight">
                Learn English{" "}
                <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
                  Your Way
                </span>
              </h2>
            </div>

            {/* 3 Balanced Feature Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {/* Feature 1: Lessons */}
              <div className="group relative bg-white/80 backdrop-blur-sm rounded-3xl border border-blue-100/80 shadow-xl hover:shadow-2xl hover:border-blue-300 hover:-translate-y-3 transition-all duration-500 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-indigo-500/5 -skew-x-3 -translate-x-8 group-hover:translate-x-0 transition-transform duration-700" />
                <div className="relative p-8 lg:p-10">
                  <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-2xl flex items-center justify-center shadow-2xl mb-6 mx-auto transform -rotate-12 group-hover:rotate-0 group-hover:scale-110 transition-all duration-500">
                    <span className="text-3xl" role="img" aria-label="Clock">
                      ⏰
                    </span>
                  </div>
                  <h3 className="text-2xl lg:text-3xl font-black text-gray-900 mb-4 text-center">
                    1-Hour Lessons
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed text-center">
                    Perfect length group or 1-on-1 sessions
                  </p>
                </div>
              </div>

              {/* Feature 2: Flexible */}
              <div className="group relative bg-white/80 backdrop-blur-sm rounded-3xl border border-indigo-100/80 shadow-xl hover:shadow-2xl hover:border-indigo-300 hover:-translate-y-3 transition-all duration-500 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-purple-500/5 -skew-y-3 translate-y-8 group-hover:translate-y-0 transition-transform duration-700" />
                <div className="relative p-8 lg:p-10">
                  <div className="w-20 h-20 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-2xl flex items-center justify-center shadow-2xl mb-6 mx-auto transform rotate-12 group-hover:rotate-0 group-hover:scale-110 transition-all duration-500">
                    <span className="text-3xl" role="img" aria-label="Calendar">
                      📅
                    </span>
                  </div>
                  <h3 className="text-2xl lg:text-3xl font-black text-gray-900 mb-4 text-center">
                    Flexible Timing
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed text-center">
                    Weekday & Weekend batches
                  </p>
                </div>
              </div>

              {/* Feature 3: Results */}
              <div className="group relative bg-white/80 backdrop-blur-sm rounded-3xl border border-purple-100/80 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-3 transition-all duration-500 overflow-hidden md:col-span-2 lg:col-span-1">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 to-pink-500/5 scale-110 group-hover:scale-100 transition-transform duration-700" />
                <div className="relative p-8 lg:p-10">
                  <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center shadow-2xl mb-6 mx-auto transform -rotate-6 group-hover:rotate-0 group-hover:scale-110 transition-all duration-500">
                    <span className="text-3xl" role="img" aria-label="Trophy">
                      🏆
                    </span>
                  </div>
                  <h3 className="text-2xl lg:text-3xl font-black text-gray-900 mb-4 text-center">
                    Real Results
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed text-center">
                    Speak confidently in work & life
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Enhanced Lesson Preview */}
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* ===== Section Header ===== */}
            <div className="text-center mb-12 lg:mb-16 px-4">
              <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-2xl shadow-xl border border-indigo-200 mb-8 backdrop-blur-sm mx-auto max-w-max">
                <span
                  className="text-2xl sm:text-3xl"
                  role="img"
                  aria-label="Lightbulb"
                >
                  💡
                </span>
                <span className="text-base sm:text-lg font-bold text-indigo-700 uppercase tracking-widest">
                  Sample Lesson
                </span>
              </div>

              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-6 leading-tight">
                Experience Our{" "}
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Teaching Method
                </span>
              </h2>
            </div>

            {/* ===== Learning Method Images ===== */}
            <div className="grid gap-6 sm:gap-8 lg:gap-10 sm:grid-cols-2 mb-14 lg:mb-20">

              {/* Group Session Image */}
              <div className="relative group overflow-hidden rounded-3xl shadow-2xl">
                <img
                  src="/images/groupDiscussion.jpeg"
                  alt="Small group English speaking session with interactive discussion"
                  className="w-full h-64 sm:h-72 md:h-80 lg:h-96 object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute bottom-6 left-6 flex items-center gap-2 px-4 py-2.5 rounded-full 
                bg-white/70 backdrop-blur-md border border-indigo-200/60 
                shadow-md pointer-events-none select-none">

                  <span className="text-indigo-600 text-lg">👥</span>

                  <span className="text-xs sm:text-sm font-semibold text-indigo-700 tracking-wide">
                    Group Sessions
                  </span>
                </div>

              </div>

              {/* Role Play Image */}
              <div className="relative group overflow-hidden rounded-3xl shadow-2xl">
                <img
                  src="/images/rolePlay.jpeg"
                  alt="English role-play practice for interviews and workplace communication"
                  className="w-full h-64 sm:h-72 md:h-80 lg:h-96 object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute bottom-6 left-6 flex items-center gap-2 px-4 py-2.5 rounded-full
                bg-white/70 backdrop-blur-md border border-purple-200/60
                shadow-md pointer-events-none select-none
                group-hover:translate-y-[-2px] transition-transform duration-300">

                  <span className="text-purple-600 text-lg">🗨️</span>

                  <span className="text-xs sm:text-sm font-semibold text-purple-700 tracking-wide">
                    Role-Play Practice
                  </span>
                </div>


              </div>

            </div>
            {/* ===== End Learning Method Images ===== */}

            {/* <div className="text-center mb-12 lg:mb-16 px-4">
              <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-2xl shadow-xl border border-indigo-200 mb-8 backdrop-blur-sm mx-auto max-w-max">
                <span
                  className="text-2xl sm:text-3xl"
                  role="img"
                  aria-label="Lightbulb"
                >
                  💡
                </span>
                <span className="text-base sm:text-lg font-bold text-indigo-700 uppercase tracking-widest">
                  Sample Lesson
                </span>
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-6 leading-tight">
                Experience Our{" "}
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Teaching Method
                </span>
              </h2>
            </div> */}

            {/* Title & Description */}
            <div className="text-center space-y-6 px-2 sm:px-4 lg:px-0">
              <h3 className="text-2xl font-black text-gray-900">
                "Small talk that works"
              </h3>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 leading-relaxed max-w-2xl mx-auto">
                Master 5 opening lines + 3 follow-ups through real-world
                role-play
              </p>
            </div>

            {/* Cards */}
            <div className="flex flex-wrap justify-center gap-4 lg:gap-6 mt-12">
              {[
                'Open with a friendly observation: "Lovely weather today — did you have a busy morning?"',
                'Use a simple follow-up: "What do you work on here?"',
                'Offer a short personal detail: "I manage client relations — I\'m always learning new software."',
                "Practice confident responses with real feedback",
              ].map((point, index) => (
                <div
                  key={index}
                  className="group flex flex-col items-start gap-4 p-6 sm:p-8 min-w-[220px] sm:min-w-[260px] flex-1 max-w-xs sm:max-w-sm bg-white/90 backdrop-blur-sm rounded-2xl lg:rounded-3xl border border-blue-100 shadow-lg hover:shadow-2xl hover:-translate-y-1 hover:border-blue-300 transition-all duration-300"
                >
                  <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-2xl flex items-center justify-center text-white font-black text-lg sm:text-2xl shadow-xl group-hover:scale-110 transition-all duration-300 border-4 border-white/50 self-start">
                    {index + 1}
                  </div>
                  <div className="flex-1 min-h-0">
                    <p className="text-gray-700 leading-snug text-sm sm:text-base font-medium">
                      {point}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="pt-12 text-center">
              <button
                onClick={() => navigate("/contact")}
                className="px-8 sm:px-12 lg:px-16 py-4 sm:py-6 text-base sm:text-xl font-black text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-700 rounded-3xl shadow-2xl shadow-purple-500/40 hover:shadow-purple-500/60 hover:scale-105 transform transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-indigo-500/50"
              >
                Book Practice Slot →
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
